module.exports = __webpack_public_path__ + "static/media/Logo_background.fed846a9.svg";